import React, { useState } from 'react';
import project0 from "../../images/project0.jpg";
import project1 from "../../images/project1.jpg";
import project2 from "../../images/project2.jpg";
import project3 from "../../images/project3.jpg";
import project4 from "../../images/project4.jpg";
import project5 from "../../images/project5.jpg";
import project6 from "../../images/project6.jpg";
import {cloneDeep} from "lodash";

const Project = () => {

  const [projects, setProjects] = useState([
    {
      id:0,
      name: 'Extraordinary Cakes (full-stack)',
      image: project0,
      shouldViewMore: false,
      details: "This full stack project uses the MERN (MongoDB,Express,React,and Node.js) structure to build an application that enables users to purchase cakes online.",
      deploy: 'https://jili-cakeshop.herokuapp.com/',
      github: 'https://github.com/JiliJiang/Cake_Shop_Deployed'
    },
    {
      id:1,
      name: 'E-Solutions (full-stack)',
      image: project1,
      shouldViewMore: false,
      details: "This full stack project uses Model-View-Control structure to build an online course library.",
      deploy: 'https://jili-esolutions.herokuapp.com/',
      github: 'https://github.com/JiliJiang/E-Solutions-New'
    },
    {
      id:2,
      name: 'Tech Blog (full-stack) ',
      image: project2,
      shouldViewMore: false,
      details: "This full stack project uses Model-View-Control structure to build a blog for users to manage posts and comments.",
      deploy: 'https://jili-tech-blog.herokuapp.com/',
      github: 'https://github.com/JiliJiang/tech-blog'
    },
    {
      id:3,
      name: 'Note Taker (full-stack)',
      image: project3,
      shouldViewMore: false,
      details: "This full stack project includes back-end and front-end structures that enable users to add, store and change notes.",
      deploy: 'https://jili-notetaker.herokuapp.com/',
      github: 'https://github.com/JiliJiang/note-taker'
    },
    {
      id:4,
      name: 'Wheather Dashboard (web API)',
      image: project4,
      shouldViewMore: false,
      details: "This front-end project fetches data from web API to enable users to view weather by searching cities and store search results in local storage.",
      deploy: 'https://jilijiang.github.io/weather-dashboard/',
      github:'https://github.com/JiliJiang/weather-dashboard'
    },
    {
      id:5,
      name: 'Code Quiz (JavaScript)',
      image: project5,
      shouldViewMore: false,
      details: "This project uses regular JavaScript to give a quiz on JavaScript knowledge and store users information and high scores in local storage.",
      deploy: 'https://jilijiang.github.io/code-quiz/',
      github: 'https://github.com/JiliJiang/code-quiz'

    },
    {
      id:6,
      name: 'Team Generator (JavaScript)',
      image: project6,
      shouldViewMore: false,
      details: "This project uses object oriented JavaScript to generate team members and render DOM elements to HTML pages and deploys testing.",
      deploy: 'https://watch.screencastify.com/v/iqq0x6FC8ESTIzDsxnde', 
      github: 'https://github.com/JiliJiang/team-generator'
    },
    
  ]);

    
const handleViewMore = (id) => {
  console.log("id", id);
  //console.log("index", i);
  const clone = cloneDeep(projects);
  const targetProject = clone.find((project) => project.id ===id);
  if (targetProject.shouldViewMore) {
    targetProject.shouldViewMore = false;
  }else {
    targetProject.shouldViewMore = true;
  }
  setProjects(clone);
}

const renderViewMorecontent = (shouldViewMore,details,deploy,github) => {
  let result = null;

  console.log(details);

  if (shouldViewMore) {
    result =  (<div className="project-text-details">
      
      <p>{details}</p>
      <a href={deploy} className ="project-text-details-a">Click to view deployed site</a>
      <a href={github} className ="project-text-details-a">Click to view GitHub repo</a>
      

      </div>)
  }
  return result;
};


  return (
    <ul className="projects">
            
        {projects.map((project) => (
          <li className="project" key={project.id} style={{ 
      backgroundImage: `url(${project.image})`}}> 
            
            <p className="project-text">{project.name}</p>

            <button className="project-text-button" onClick={() => handleViewMore(project.id)}>
              {project.shouldViewMore ?"View Less":"View More"}
              
            </button>
            
            {renderViewMorecontent(project.shouldViewMore,project.details, project.deploy, project.github)}

          </li>      
        ))};

        
      
    </ul>
  );
};


export default Project
